const DEFAULT_API_URL = 'https://api.core-utils.app';

export function getApiUrl(): string {
  return import.meta.env.VITE_API_URL ?? DEFAULT_API_URL;
}

export function getSiteUrl(): string {
  return import.meta.env.VITE_SITE_URL ?? 'https://core-utils.app';
}
